// extracted by mini-css-extract-plugin
export default {"btnViewReplies":"Replies_btnViewReplies__YFrqu","btnViewRepliesIcon":"Replies_btnViewRepliesIcon__io75S","btnViewRepliesIconActive":"Replies_btnViewRepliesIconActive__FOY1K"};